import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

import TableData from '../table/table.vue';
import FilterBar from '../filter-bar/filter-bar.vue';
import { Pagination as LPagination } from '@/components/index';

export default {
    name: 'RaceRegistrationLayout',
    components: {
        'table-data': TableData,
        'filter-bar': FilterBar,
        LPagination

    },
    props: {
        id: [Number, String]
    },
    watch: {
        filter: {
            immediate: true,
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
                    return;
                }
                if (!oldVal) {
                    this.init();
                }
                else {
                    this.load();
                }
            }
        },
        page: {
            immediate: true,
            handler(newVal) {
                if (newVal != this.filter.options.page) {
                    this.filter.options.page = newVal;
                    this.load();
                }
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            tableData: [],
            filter: {
                userId: null,
                userName: null,
                ageGroup: 0,
                isParatriathlete: null,
                gender: 0,
                isTransfer: null,
                options: { skip: 0, take: 5, perPage: 5, page: 1 }
            },
            total: 0,
            page: 1,
            ageGroups: [],
        }
    },
    computed: {
        isNeedSupportData() {
            return !this.ageGroups || !this.ageGroups.length;
        },
        skip() {
            return (this.filter.options.page - 1) * this.filter.options.perPage;
        },
        take() {
            return this.filter.options.perPage;
        },
        from() {
            return this.skip + 1;
        },
        to() {
            return this.skip + this.take;
        },
        filterQuery() {
            return this.createQueryString(this.getFilter());
        },
        filterExportQuery() {
            return this.createQueryString(this.getExportFilter());
        },
        isUseTIsystem() {
            return this.$parent.is_use_ti_for_entry;
        }
    },
    methods: {
        init() {
            this.load();
        },
        getFilter() {
            let filter = { ...this.filter };
            filter.options.skip = this.skip;
            filter.options.take = this.take;
            filter.isNeedSupportData = this.isNeedSupportData;
            filter.raceId = this.id;
            filter.isUseTIsystem = this.isUseTIsystem;
            return filter;
        },
        getExportFilter() {
            let filter = { ...this.filter };
            filter.options.skip = 0;
            filter.options.take = 10000;
            filter.raceId = this.id;
            filter.isUseTIsystem = this.isUseTIsystem;
            return filter;
        },
        createQueryString(data, parentKey) {
            var parent = parentKey ? parentKey + "." : '';
            var result = parentKey ? "" : '?';

            Object.keys(data).map(key => {
                let value = data[key];

                if (value == null || value == undefined) {
                    return;
                }
                else if (typeof value === 'object') {
                    result += this.createQueryString(value, parent + key);
                }
                else {
                    result += `${parent}${key}=${encodeURIComponent(`${value}`)}&`;
                }
            });

            if (!parentKey) {
                result = result.substring(0, result.length - 1);
            }
            return result;
        },
        load() {
            const self = this;
            self.isProcessing = true;
            self.tableData = [];
            request.getRegistrationsForRaceList(self.filterQuery)
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        self.tableData = res.body.outputData.result;
                        self.total = res.body.outputData.total;
                        if (self.isNeedSupportData) {
                            if (res.body.outputData.ageGroups && res.body.outputData.ageGroups.length) {
                                self.ageGroups = res.body.outputData.ageGroups;
                                self.ageGroups.unshift({ label: "Any", id: 0 });
                            }
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        createUsersSheet(data) {
            var self = this;
            var isParent = data.filter(x => x["userData"] && x["userData"]['Parent TI Number']).length > 0;
            return data
                .map(x => {
                    var dataItem = {
                        'Name of Race': x['raceName'],
                        'TI Number': x.userData['TI Number'],
                        'First Name': x.userData['First Name'],
                        'Last Name': x.userData['Last Name'],
                        'Entry Status': x['statusString'],
                        'Received transfer from:': x['transferId'] == 0 ? x['receivedFromUser'] : '',
                        'Transferred registration to': x['transferId'] && x['transferId'] != 0 && x['statusString'] == 'Cancelled' ? this.$getTriathlonId(x['transferId']) : '',
                        'Gender': x.userData['Gender'],
                        'DOB': x.userData['Date of Birth'] ? x.userData['Date of Birth'].split(" ").filter(item => item && item.indexOf(':') == -1).join(' ') : null,
                        'Age Group': x['ageGroupLabel'],
                        'Email': x.userData['Email'],
                        'Phone': x.userData['Phone'],
                        'Other Phone': x.userData['Other Phone'],
                        'Country': x.userData['Country'],
                        'County': x.userData['Country'] == 'Ireland' ? x.userData['County'] : '',
                        'County Outside Ireland': x.userData['Country'] != 'Ireland' ? x.userData['County Outside Ireland'] : '',
                        'Address': x.userData['Address 1'] + " " + x.userData['Address 2'] + " " + x.userData['Address 3'],
                        'Receive Marketing Information': x['acceptMarketingInfo'],
                    };

                    if (!this.isUseTIsystem) {
                        dataItem['Purchase date'] = x['createdDateTimeString'] ? x['createdDateTimeString'] : '';

                        dataItem['Is ODL Set By Admin'] = x['isOdlSetByAdmin'] ? x['isOdlSetByAdmin'] : '';
                        dataItem['ODL Number'] = x['odlIdString'] ? x['odlIdString'] : '';
                        dataItem['ODL Price'] = x['odlPriceString'] ? x['odlPriceString'] : '';

                        dataItem['Club'] = x.userData['Club'] ? x.userData['Club'] : '';
                        dataItem['Current License'] = x.userData['Current License'] ? x.userData['Current License'] : '';
                    }
                    else {
                        dataItem['Date of Registration'] = x['createdDateTimeString'] ? x['createdDateTimeString'] : '';
                        
                        dataItem['Race Opening Number'] = x['raceOpeningNumber'];

                        dataItem['Is ODL Purchased'] = x['isOdlString'] ? x['isOdlString'] : 'No';
                        dataItem['ODL Number'] = x['odlId'] ? x['odlId'] : '';
                        dataItem['Is ODL Set By Admin'] = x['isOdlSetByAdmin'] ? x['isOdlSetByAdmin'] : '';
                        dataItem['Is Relay'] = x['isRelayString'] ? x['isRelayString'] : '';
                        dataItem['Is Relay Captain'] = x['isRelayCaptainString'] ? x['isRelayCaptainString'] : '';
                        dataItem['Relay Name'] = x['relayName'] ? x['relayName'] : '';

                        dataItem['Club'] = x.userData['Club'] ? x.userData['Club'] : '';
                        dataItem['Current License'] = x.userData['Current License'] ? x.userData['Current License'] : '';
                        dataItem['Category'] = x.userData['Division 1 Status'] ? x.userData['Division 1 Status'] : '';
                    }                   

                    dataItem['Emergency Contact Email'] = x.userData['Emergency Contact Email'] ? x.userData['Emergency Contact Email'] : '';
                    dataItem['Emergency Contact Name'] = x.userData['Emergency Contact Name'] ? x.userData['Emergency Contact Name'] : '';
                    dataItem['Emergency Contact Phone'] = x.userData['Emergency Contact Phone'] ? x.userData['Emergency Contact Phone'] : '';
                    dataItem['Emergency Contact Relation'] = x.userData['Emergency Contact Relation'] ? x.userData['Emergency Contact Relation'] : '';

                    dataItem['Para Triathlete'] = x.userData['Para Triathlete'] ? x.userData['Para Triathlete'] : '';
                    dataItem['Para Triathlete Details'] = x.userData['Para Triathlete Details'] ? x.userData['Para Triathlete Details'] : '';

                    if (this.isUseTIsystem) {
                        dataItem['Ever Done Triathlon'] = x['everDoneTriathlonString'] ? x['everDoneTriathlonString'] : '';
                        dataItem['Extra Info'] = x['extraInfo'] ? x['extraInfo'] : '';
                        dataItem['Where Hear'] = x['whereHear'] ? x['whereHear'] : '';
                        dataItem['School Name'] = x['whatSchool'] ? x['whatSchool'] : '';
                        dataItem['Health Issues'] = x['healthIssues'] ? x['healthIssues'] : '';
                        dataItem['Estimated Swim Time'] = x['estimatedSwimTime'] ? x['estimatedSwimTime'] : '';
                        dataItem['Estimated Run Time'] = x['estimatedRunTime'] ? x['estimatedRunTime'] : '';
                        dataItem['Estimated Bike Time'] = x['estimatedBikeTime'] ? x['estimatedBikeTime'] : '';
                    }

                    if (isParent) {
                        dataItem['Parent TI Number'] = x.userData['Parent TI Number'] ? x.userData['Parent TI Number'] : '';
                        dataItem['Parent FirstName'] = x.userData['Parent FirstName'] ? x.userData['Parent FirstName'] : '';
                        dataItem['Parent LastName'] = x.userData['Parent LastName'] ? x.userData['Parent LastName'] : '';
                        dataItem['Parent Phone'] = x.userData['Parent Phone'] ? x.userData['Parent Phone'] : '';
                        dataItem['Parent Other Phone'] = x.userData['Parent Other Phone'] ? x.userData['Parent Other Phone'] : '';
                        dataItem['Parent Email'] = x.userData['Parent Email'] ? x.userData['Parent Email'] : '';
                        dataItem['Email'] = dataItem['Parent TI Number'] ? dataItem['Parent Email'] : dataItem['Email'];
                        dataItem['Parent County'] = dataItem['Parent County'] ? dataItem['Parent County'] : '';
                        dataItem['Parent Address'] = x.userData['Parent Address 1'] ? x.userData['Parent Address 1'] : '';
                        if (x.userData['Parent Address 2']) {
                            dataItem['Parent Address'] += " " + x.userData['Parent Address 2'];
                        }
                        if (x.userData['Parent Address 3']) {
                            dataItem['Parent Address'] += " " + x.userData['Parent Address 3'];
                        }
                    }

                    if (x.payment && this.isUseTIsystem) {
                        dataItem['Base Price'] = x.payment['baseAmount'];
                        dataItem['Discount'] = x.payment['discount'];
                        dataItem['Discount Code'] = x.payment['discountCode'];
                        dataItem['Net Price'] = x.payment['netAmount'];
                        dataItem['ODL Price'] = x.payment['odmAmount'];
                        dataItem['Refunded'] = x.payment['refunded'];
                    }
                    else if (this.isUseTIsystem) {
                        dataItem['Base Price'] = 0;
                        dataItem['Discount'] = 0;
                        dataItem['Discount Code'] = "";
                        dataItem['Net Price'] = 0;
                        dataItem['ODL Price'] = 0;
                        dataItem['Refunded'] = 0;
                    }

                    if (x.merchandisePurchases && x.merchandisePurchases.length && this.isUseTIsystem) {
                        for (let i = 0; i < x.merchandisePurchases.length; i++) {
                            var headerAmount = 'Merch ' + x.merchandisePurchases[i]['size'] + ' Amount';
                            var headerPrice = 'Merch ' + x.merchandisePurchases[i]['size'] + ' Price';
                            if (!dataItem[headerAmount]) {
                                dataItem[headerAmount] = '';
                            }
                            if (!dataItem[headerPrice]) {
                                dataItem[headerPrice] = '';
                            }
                            dataItem[headerAmount] += x.merchandisePurchases[i].amount;
                            dataItem[headerPrice] += x.merchandisePurchases[i].price;
                        }
                    }
                    let parsedUserId = self.$getTriathlonId(parseInt(x.userData['TI Number']));
                    
                    return dataItem;
                })
        },
        exportData() {
            var self = this;
            self.isProcessing = true;
            request.getRegistrationsForRaceList(self.filterExportQuery)
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        var data = res.body.outputData.result;
                        if (data && data.length > 0) {
                            var ws = XLSX.utils.json_to_sheet(self.createUsersSheet(data));
                            var wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Race Entries");
                            XLSX.writeFile(wb, "Race Entries.xlsx");
                        }
                        else {
                            this.$showError("There are no entries to export");
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null);
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },
        createMerchFirstSheet(data) {
            return data.map(x => {
                var dataItem = {
                    "TI Number": x.createdByTiNumber,
                    "First Name": x.firstName,
                    "Middle Name": x.middleName,
                    "Last Name": x.lastName,
                    "Gender": x.gender,
                    "Date of Birth": x.dob,
                    "Merchandise Name": x.merchandiseName,
                    "Size": x.size,
                    "Amount": x.amount,
                    "Price": x.price
                };
                return dataItem;
            });
        },
        createMerchSecondSheet(data) {
            var result = [];
            if (data && data.length) {
                data.forEach(item => {
                    var newItem = { "Merch Name": item.merchandiseName, "Size": item.size, "Price": item.price, "No of Purchases": item.amount }
                    var isUsed = false;
                    result.forEach(x => {
                        if (!isUsed && x["Merch Name"] == newItem["Merch Name"] && x["Size"] == newItem["Size"] && x["Price"] == newItem["Price"]) {
                            x["No of Purchases"] += newItem["No of Purchases"];
                            isUsed = true;
                        };
                    })
                    if (!isUsed) {
                        result.push(newItem)
                    }
                });
            }

            return result;
        },
        exportMerchandiseData() {
            var self = this;
            self.isProcessing = true
            request.getMerchandisesPerUserForRaceList(self.id)
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        var data = res.body.outputData;
                        if (data && data.length > 0) {
                            var ws1 = XLSX.utils.json_to_sheet(self.createMerchFirstSheet(data));
                            var ws2 = XLSX.utils.json_to_sheet(self.createMerchSecondSheet(data));
                            var wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws1, "Per User");
                            XLSX.utils.book_append_sheet(wb, ws2, "Total");
                            XLSX.writeFile(wb, "Merchandise.xlsx");
                        }
                        else {
                            this.$showError("There is no merchandise to export");
                        }

                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null);
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError()
                    })
        }
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-registration/layout/layout.js